import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Servicos from "@/pages/Servicos";
import ServicoDetail from "@/pages/ServicoDetail";
import Bairros from "@/pages/Bairros";
import BairroDetail from "@/pages/BairroDetail";
import Sobre from "@/pages/Sobre";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Contato from "@/pages/Contato";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/servicos.html" element={<Servicos />} />
            <Route path="/servicos/:slug.html" element={<ServicoDetail />} />
            <Route path="/bairros.html" element={<Bairros />} />
            <Route path="/bairros/:slug.html" element={<BairroDetail />} />
            <Route path="/sobre.html" element={<Sobre />} />
            <Route path="/blog.html" element={<Blog />} />
            <Route path="/blog/:slug.html" element={<BlogPost />} />
            <Route path="/contato.html" element={<Contato />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
